export const getPeopleAhead = (
	ticketNumber,
	currentAttentionNumber,
	inserted_at
) => {
	if (isNaN(ticketNumber) || isNaN(currentAttentionNumber)) return null;

	if (!inserted_at && ticketNumber === 0) return ticketNumber - 1;

	return ticketNumber - currentAttentionNumber;
};
